import {
	BUSINESS_SEARCH_FAILED,
	BUSINESS_SEARCH_REQUEST,
	BUSINESS_SEARCH_SUCCESS,
} from './actionTypes'

const initialState = {
	isLoading: false,
	businessList: [],
	errors: null,

	pagination: {
		currentPage: 1,
		totalItem: 0,
		perPage: 15,
	},
}

const reducer = (state = initialState, action) => {
	switch (action.type) {
		/**
		 * User login
		 */
		case BUSINESS_SEARCH_REQUEST:
			return {
				...state,
				isLoading: true,
			}
		case BUSINESS_SEARCH_SUCCESS:
			let businessList = []
			if (action.isAppended) {
				businessList = [...state.businessList, ...action.payload.data]
			} else {
				businessList = action.payload?.data
			}

			return {
				...state,
				isLoading: false,
				businessList: businessList,
				pagination: {
					currentPage: action.payload?.current_page,
					totalItem: action.payload?.total,
					perPage: action.payload?.per_page,
				},
			}
		case BUSINESS_SEARCH_FAILED:
			return {
				...state,
				errors: action.errors,
			}
		default:
			return state
	}
}

export default reducer
